import "./additionalInfo.css";
import { IMaskInput } from "react-imask";

function AdditionalInfo({ setConfirmationModal }) {
  return (
    <section className="additional_info_wrapper">
      <p className="basic_info_text">Additional Information</p>

      <form className="partner_additional_wrapper">
        <div className="pan_vote_card">
          {/* PAN Card - Changed to type="text" because PAN includes letters */}
          <label htmlFor="panCard" className="partner_form_label">
            <p className="partner_form_para">PAN Card</p>
            <input
              type="text"
              className="partner_form_input"
              placeholder="Enter PAN Number"
              style={{ textTransform: "uppercase" }} // Optional: capitalizes input
            />
          </label>

          {/* Voter ID - Changed to type="text" because Voter IDs include letters */}
          <label htmlFor="voterId" className="partner_form_label">
            <p className="partner_form_para">Voter Id</p>
            <input
              type="text"
              className="partner_form_input"
              placeholder="Enter Voter ID"
              style={{ textTransform: "uppercase" }}
            />
          </label>
        </div>

        <div className="more_card_container">
          {/* Aadhaar - Using IMaskInput to fix the crash */}
          <label htmlFor="aadhaar" className="partner_form_label">
            <p className="partner_form_para">Aadhaar Number</p>
            <IMaskInput
              className="partner_form_input"
              mask="0000 0000 0000" // Standard Aadhaar format (0 = any digit)
              definitions={{
                '#': /[1-9]/,
              }}
              placeholder="0000 0000 0000"
            />
          </label>

          {/* Passport - Changed to type="text" because Passports are alphanumeric */}
          <label htmlFor="passport" className="partner_form_label">
            <p className="partner_form_para">Passport</p>
            <input
              type="text"
              className="partner_form_input"
              placeholder="Enter Passport Number"
              style={{ textTransform: "uppercase" }}
            />
          </label>

          <label htmlFor="certificate" className="partner_upload_label">
            <p className="partner_form_para">
              Company Registration Certificate
            </p>
            <button
              type="button"
              onClick={() => {
                setConfirmationModal({
                  heading: "Please upload your company certificate",
                  subHeading: "Select relevant documents to complete your kyc",
                  type: "file",
                });
              }}
              className="partner_upload_file"
            >
              Upload File
            </button>
          </label>
        </div>
      </form>
    </section>
  );
}

export default AdditionalInfo;